// extracted by mini-css-extract-plugin
module.exports = {"date":"CalendarDate_date__10mzd","reserved":"CalendarDate_reserved__3SGk1","selected":"CalendarDate_selected__2Oyiu","today":"CalendarDate_today__2Oz72"};